import { Card, Grid, styled, Typography } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import { card, slimPadding, capitalize, fontSize2 } from 'assets/jss/styles';

export const PickerWrapper = styled(Grid)(() => ({
  width: '100%',
  margin: '0 auto'
}));

export const PaginationFilter = styled(Grid)(() => ({
  paddingBottom: '5px !important',
  '& .MuiPaper-root': {
    margin: '0'
  }
}));

export const FloatRight = styled(Grid)(() => ({
  paddingBottom: '5px !important',
  '& .MuiPaper-root': {
    margin: '0'
  }
}));

export const ResultWrapper = styled(Grid)(() => ({
  '& .MuiPaper-root': {
    margin: '0'
  }
}));

export const FilterSliderWrapper = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

export const BoldTextWrapper = styled('span')(() => ({
  fontWeight: 'bold',
  float: 'left'
}));

export const AssetDetailSliderWrapper = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(-2),
  verticalAlign: 'baseline'
}));

export const OfferCardWrapper = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(0),
  paddingBottom: theme.spacing(1)
}));

export const IconCardWrapper = styled('img')(() => ({
  height: '140px'
}));

export const CompactFormWrapper = styled(Grid)(({ theme }) => ({
  compactForm: {
    '& .MuiFormControl-root': {
      marginBottom: theme.spacing(1)
    },
    '& .MuiFormControl-root .MuiFormHelperText-root': {
      position: 'absolute',
      bottom: '-1.5rem'
    }
  }
}));

export const ClientContainerWrappper = styled(Grid, {
  shouldForwardProp: prop => !['matches'].includes(prop)
})(({ matches }) => ({
  paddingTop: '0 !important',
  paddingBottom: '5px !important',
  ...(matches && {
    '& .MuiPaper-root': {
      height: '340px'
    }
  })
}));

export const OfferGridWrapper = styled(Grid, {
  shouldForwardProp: prop => !['matchesLg'].includes(prop)
})(({ matchesLg }) => ({
  paddingTop: '0 !important',
  paddingBottom: '5px !important',
  ...(matchesLg && {
    '& .MuiPaper-root': {
      height: '340px'
    }
  })
}));

export const AssetImageWrapper = styled(Grid, {
  shouldForwardProp: prop => !['matchesMd'].includes(prop)
})(({ matchesMd }) => ({
  width: '90%',
  margin: '0 auto',
  textAlign: 'center',
  ...(matchesMd && {
    width: '50%',
    textAlign: 'end',
    borderRight: '1px solid rgba(0, 0, 0, 0.08)'
  })
}));

export const AssetDetailWrapper = styled(Grid, {
  shouldForwardProp: prop => !['matchesMd', 'theme'].includes(prop)
})(({ matchesMd, theme }) => ({
  width: '100%',
  textAlign: 'center',
  padding: theme.spacing(1),
  marginTop: theme.spacing(1),
  rowGap: theme.spacing(3),
  ...(matchesMd && {
    width: '50%',
    textAlign: 'start',
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(2)
  })
}));

export const StepperCard = styled(Card)(({ theme }) => ({
  px: theme.spacing(1),
  card: card(theme),
  stepperCard: { ...card, margin: 0 },
  slimPadding,
  capitalize,
  fontSize2,
  nextStepButton: {
    ml: theme.spacing(-1),
    mr: theme.spacing(-8),
    justifyContent: 'flex-start'
  }
}));

export const ProductTitleWrapper = styled(Typography)(() => ({
  fontWeight: 'bold',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  color: 'primary',
  textAlign: 'center'
}));

export const ServicesWrapper = styled(Grid)(({ theme }) => ({
  minHeight: theme.spacing(10),
  width: '100%',
  textAlign: 'center',
  padding: theme.spacing(1)
}));

export const ServicesAreaWrapper = styled(Grid)(({ theme }) => ({
  height: theme.spacing(7),
  display: 'flex',
  overflow: 'auto'
}));

export const ServicesTextWrapper = styled(Grid)(() => ({
  margin: 'auto',
  color: 'primary'
}));

export const ServicesPlaceholderWrapper = styled('span')(() => ({
  fontSize: '20px'
}));

export const ProductButtonWrapper = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(1),
  width: '200px'
}));

export const FinancialProductCardWrapper = styled(Grid, {
  shouldForwardProp: prop => !['selectedProductId', 'theme'].includes(prop)
})(({ selectedProductId, theme }) => ({
  paddingTop: theme.spacing(0),
  paddingBottom: theme.spacing(1),
  ...(selectedProductId && {
    '& .MuiPaper-root': {
      border: '1px solid',
      borderColor: theme.palette.timColors.themeColor,
      borderRadius: '6px',
      boxShadow: '5px 5px 5px 5px #bdbdbd'
    }
  })
}));
